<template>
  <!-- 贸易结算水表(终端用户远传表) -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-tabs default-active-key="全部" v-model="query.status" @change="callback">
        <a-tab-pane key tab="全部"></a-tab-pane>
        <a-tab-pane :key="0" tab="未开始"></a-tab-pane>
        <a-tab-pane :key="1" tab="执行中"></a-tab-pane>
        <a-tab-pane :key="2" tab="已提交"></a-tab-pane>
        <a-tab-pane :key="3" tab="已完成"></a-tab-pane>
      </a-tabs>
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="工单编号"> 
              <a-input v-model="query.workNo" placeholder="请输入工单编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="工单名称">
              <a-input v-model="query.workName" placeholder="请输入工单名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="维修泵房">
              <a-input v-model="query.pumpName" placeholder="请输入维修泵房" allow-clear />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="PublishTask()" v-action:add>新增</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="exportHandle()">导出</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      bordered
      :scroll="{ x: 2100 }"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <template slot="action" slot-scope="text, record">
        <a style="margin-right: 5px" @click="detailed(record.id)" v-action:edit>详情</a>
        <!-- <a v-if="record.status != 1" style="margin-right: 5px" @click="deleteSelectRow(record.id)">删除</a> -->

        <div v-if="record.status == 1">
          <a style="margin-right: 5px" @click="delay(record)">延期</a>
          <a style="margin-right: 5px" @click="UrgeHandle(record.id)">催办</a>
          <a style="margin-right: 5px" @click="ReassignHandle(record)">转派</a>
        </div>
      </template>
      <span slot="createTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <span slot="planTime" slot-scope="text" v-if="text !== null">{{ text }} 天</span>
      <span slot="processingTime" slot-scope="text" v-if="text !== null">{{ text }}</span>
      <template slot="statusAction" slot-scope="text">
        <span v-if="text == 0">
          <a-tag color="rgb(255, 99, 71)"> 未开始 </a-tag>
        </span>
        <span v-else-if="text == 1">
          <a-tag color="#f98303"> 执行中 </a-tag>
        </span>
        <span v-else-if="text == 2">
          <a-tag color="#40a9ff"> 已提交 </a-tag>
        </span>
        <span v-else>
          <a-tag color="rgb(50, 205, 50)"> 已完成 </a-tag>
        </span>
        <!-- <span v-if="text == 0">未开始</span>
        <span v-if="text == 1">执行中</span>
        <span v-if="text == 2">已提交</span>
        <span style="color: blue" v-if="text == 3">已完成</span> -->
      </template>
    </a-table>

    <order-modal ref="OrderModal" @handleOk="queryList"></order-modal>
    <a-modal
      title="详情"
      style="top: 20px"
      :width="800"
      :footer="null"
      :visible="visibles"
      :confirm-loading="confirmLoading"
      @cancel="handleCancelh"
    >
          <a-row style="margin-top: 20px">
        <a-col :span="12">关联任务：{{ detail.taskNo }}</a-col>
        <a-col :span="12"></a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">工单编号：{{ detail.workNo }}</a-col>
        <a-col :span="12">工单名称: {{ detail.workName }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">维修泵房：{{ detail.pumpName }}</a-col>
        <a-col :span="12">工单来源: {{ detail.workOrderSource }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">负责人: {{ detail.principalName }}</a-col>
        <a-col :span="12">其他维修人员：{{ detail.maintenanceName }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">预期开始时间：{{ detail.predictStime }}</a-col>
        <a-col :span="12"
          >预期处理时长: <span v-if="detail.planTime !== null">{{ detail.planTime }}天</span></a-col
        >
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">开始时间：{{ detail.startTime }}</a-col>
        <a-col :span="12"
          >处理时长: <span v-if="detail.processingTime !== null">{{ detail.processingTime }}</span></a-col
        >
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12"
          >工单状态：

          <span v-if="detail.status == 0"> <a-tag color="rgb(255, 99, 71)"> 未开始 </a-tag></span>
          <span v-if="detail.status == 1"> <a-tag color="#f98303"> 执行中 </a-tag></span>
          <span v-if="detail.status == 2"><a-tag color="#40a9ff"> 已提交 </a-tag></span>
          <span v-if="detail.status == 3"><a-tag color="rgb(50, 205, 50)"> 已完成 </a-tag></span></a-col
        >
        <a-col :span="12"> 工单内容：{{ detail.deviceName }} </a-col>
        <!-- <a-col :span="12" v-if="detail.status !== 1">描述：{{ detail.noteContent }}</a-col>
        <a-col :span="12" v-if="detail.status == 1">描述：{{ detail.draftNoteContent }}</a-col> -->
      </a-row>

      <div v-if="detail.isWaterOffEvent == 1">
        <div v-if="detail.gisWaterEvent !== null">
          <a-row style="margin-top: 20px">
            <a-col :span="12"
              >是否需要新增停水事件:<span v-if="detail.isWaterOffEvent == 1">是</span><span v-else>否</span></a-col
            >
            <a-col :span="12"
              >是否关联停水事件:<span v-if="detail.isRelationWaterOffEvent == 1">是</span><span v-else>否</span></a-col
            >
          </a-row>
          <a-row style="margin-top: 20px">
            <a-col :span="12">关联停水事件：{{ detail.gisWaterEvent.eventName + detail.gisWaterEvent.eventNo }}</a-col>
            <a-col :span="12">事件名称：{{ detail.gisWaterEvent.eventName }}</a-col>
          </a-row>
          <a-row style="margin-top: 20px">
            <a-col :span="12">爆管管段：<a-button type="primary" @click="openMap()">查看管道</a-button></a-col>
            <a-col :span="12">停水管理员：{{ detail.gisWaterEvent.waterAdminName }}</a-col>
          </a-row>
          <a-row style="margin-top: 20px">
            <a-col :span="12">开始分类编码：{{ detail.gisWaterEvent.startClassNo }}</a-col>
            <a-col :span="12">结束分类编码：{{ detail.gisWaterEvent.endClassNo }}</a-col>
          </a-row>
          <a-row style="margin-top: 20px">
            <a-col :span="12">计划停水开始时间：{{ detail.gisWaterEvent.planStartTime }}</a-col>
            <a-col :span="12">计划停水结束时间：{{ detail.gisWaterEvent.planEntTime }}</a-col>
          </a-row>
          <a-row style="margin-top: 20px">
            <a-col :span="12">事件描述：{{ detail.gisWaterEvent.describe }}</a-col>
            <a-col :span="12"></a-col>
          </a-row>
        </div>
      </div>
      <a-row style="margin-top: 20px">
        <a-col :span="12">
          <div class="fileDiv">
            完成图片：
            <ul v-if="detail.status == 1">
              <li class="fileLi" v-for="item in detail.draftCompleteFileNames" :key="item.url">
                <img :src="item.url" alt="" style="width: 80px; height: 80px" @click="clicimg(item.url)" />
              </li>
            </ul>
            <ul v-else>
              <li class="fileLi" v-for="item in detail.completeFileNames" :key="item.url">
                <img :src="item.url" alt="" style="width: 80px; height: 80px" @click="clicimg(item.url)" />
              </li>
            </ul>
          </div>
        </a-col>
        <a-col :span="12">
          <!-- <a-col :span="12">处理结果：{{ detail.consequence }}</a-col> -->
          <a-col :span="12" v-if="detail.status !== 1">处理结果：{{ detail.consequence }}</a-col>
          <a-col :span="12" v-if="detail.status == 1">处理结果：{{ detail.draftConsequence }}</a-col>
        </a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12"
          >处理记录：
          <a-form-model-item style="margin-top: 16px" label="" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <a-timeline>
              <a-timeline-item v-for="item in detail.records" :key="item.id">
                <span>{{ item.createTime }}</span>
                <span style="color: blue; margin-left: 20px">{{ item.name }}</span>
                <span style="margin-left: 10px">{{ item.message }}</span>
              </a-timeline-item>
            </a-timeline>
          </a-form-model-item></a-col
        >
      </a-row>
    </a-modal>
    <a-modal class="log-form" :title="'选取位置'" width="50%" v-model="showMap" @ok="closeMap" @cancel="closeMap2">
      <input class="login-input" type="text" v-model="startLine" placeholder="请输入开始分类编码" />
      <input class="login-input" type="text" v-model="endLine" placeholder="请输入结束分类编码" />
      <a-button type="submit" @click="searchMapLine">查询</a-button>
      <mapTemplate ref="waterMap" v-on:childByValue="childByValue"></mapTemplate>
    </a-modal>
    <a-modal
      title="延期"
      style="top: 20px"
      :width="500"
      :visible="visibledelay"
      :confirm-loading="confirmLoading"
      @cancel="handleCancedelay"
      @ok="handleOkdelay"
    >
      <a-form-model
        class="log-form"
        :model="UpdateForm"
        ref="UpdateForm"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="预计处理时长" prop="planTime">
          <a-input v-model="UpdateForm.planTime" placeholder="请输入预计处理时长" allow-clear />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
      title="图片"
      style="top: 20px"
      :width="800"
      :footer="null"
      :visible="visiblest"
      :confirm-loading="confirmLoading"
      @cancel="handleCancelhlg"
    >
      <img :src="this.pumpUrlg" :alt="this.pumpUrlg" style="width: 100%; height: 100%" />
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixin/commonModel'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import OrderModal from './modules/OrderModal'
import mapTemplate from '@/views/Water-outage-control/map-template.vue'
const columns = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    width: 70,
    align: 'center',
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },
  {
    title: '工单编号',
    dataIndex: 'workNo',
  },
  {
    title: '工单名称',
    dataIndex: 'workName',
    ellipsis: true,
  },
  {
    title: '维修泵房',
    dataIndex: 'pumpName',
  },
  {
    title: '工单来源',
    dataIndex: 'workOrderSource',
  },
  {
    title: '工单内容',
    dataIndex: 'deviceName',
    ellipsis: true,
  },
  {
    title: '负责人',
    dataIndex: 'principalName',
  },
  {
    title: '其他维修人员',
    dataIndex: 'maintenanceName',
  },
  {
    title: '预期开始时间',
    dataIndex: 'predictStime',
  },
  {
    title: '预期处理时长',
    dataIndex: 'planTime',
    scopedSlots: { customRender: 'planTime' },
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
  },
  {
    title: '处理时长',
    dataIndex: 'processingTime',
    scopedSlots: { customRender: 'processingTime' },
  },
  {
    title: '工单状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'statusAction' },
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    fixed: 'right',
    width: 90,
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  components: {
    OrderModal,
    mapTemplate,
  },
  name: 'OrderManagement',
  data() {
    return {
      startLine: '',
      endLine: '',
      showMap: false,
      currentId: '',
      queryUrl: '/pipe-network/work_order_managements/page',
      deleteUrl: '/pipe-network/work_order_managements',
      addOrUpdateUrl: '/pipe-network/inspection_tasks',
      queryOneUrl: '/pipe-network/inspection_tasks',
      exportDataUrl: 'pipe-network/work_order_managements/export',
      exportFileName: '工单表.xlsx',
      query: {
        pumpName: '',
        workName: '',
        workNo: '',
        status: '',
        workOrderType: '',
        deviceName: '',
        deviceNo: '',
        maintenancePerson: '',
        sysType: '二次供水',
      },
      pumpUrlg: '',
      visiblest: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      addOrUpdateForm: {
        eventName: '',
        eventType: '',
        address: '',
        reportPerson: '',
        phone: '',
        reportTime: '',
        eventDescription: '',
        accessorys: [],
        sysType: '二次供水',
      },
      UpdateForm: {
        id: '',
        planTime: '',
      },
      statu: '',
      visibles: false,
      confirmLoading: false,
      visibledelay: false,
      uploadUrl: process.env.VUE_APP_API_BASE_URL + 'manager/file/resources/upload',
      TaskList: [],
      detail: [],
      eventTypeList: [],
      OrderTypeList: [], //工单类型
    }
  },
  filters: {
    permissionFilter(key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    },
  },
  computed: {
    rules() {
      return {
        planTime: [{ required: true, message: '请选择完成时间', trigger: 'change' }],
      }
    },
  },
  created() {
    this.getTaskList()
    this.getOrderTypeList()
    this.resetList()
  },
  methods: {
    clicimg(i) {
      this.pumpUrlg = i
      this.visiblest = true
    },
    handleCancelhlg() {
      this.visiblest = false
      this.pumpUrlg = ''
    },
    changeStartAndEnd(start, end) {
      this.startLine = start
      this.endLine = end
    },
    openMap(i) {
      this.startLine = this.detail.gisWaterEvent.startClassNo || ''
      this.endLine = this.detail.gisWaterEvent.endClassNo || ''
      this.showMap = true

      if (this.startLine.length > 0 || this.endLine.length > 0) {
        this.$nextTick(() => {
          this.$refs.waterMap.searchLines(this.startLine, this.endLine)
        })
      }
    },
    closeMap() {
      this.showMap = false
      this.detail.gisWaterEvent.startClassNo = this.startLine
      this.detail.gisWaterEvent.endClassNo = this.endLine
      this.$refs.waterMap.redSource.clear()
    },
    closeMap2() {
      this.showMap = false
      this.startLine = ''
      this.endLine = ''
      this.$refs.waterMap.redSource.clear()
    },
    searchMapLine() {
      this.$refs.waterMap.searchLines(this.startLine, this.endLine)
    },
    handleOkdelay() {
      this.$refs.UpdateForm.validate((valid) => {
        if (valid) {
          this.$http.put('/pipe-network/work_order_managements', { ...this.UpdateForm }).then((res) => {
            if (res.code == 0) {
              this.$message.success(`延期成功`)
              this.$refs.UpdateForm.resetFields()
              this.queryList()
              this.visibledelay = false
            } else {
              this.$message.success(`延期失败！`)
              this.$refs.UpdateForm.resetFields()
              this.queryList()
              this.visibledelay = false
            }
          })
        }
      })
    },
    handleCancedelay() {
      this.$refs.UpdateForm.resetFields()
      this.visibledelay = false
    },
    detailed(id) {
      this.currentId = id
      this.$http.get(`/pipe-network/work_order_managements/${this.currentId}`).then((res) => {
        this.detail = res.data
        console.log(res.data)
      })

      this.visibles = true
    },
    handleCancelh() {
      this.visibles = false
    },
    delay(record) {
      this.UpdateForm.id = record.id
      this.UpdateForm.planTime = record.planTime
      this.visibledelay = true
    },
    UrgeHandle(id) {
      const _this = this
      this.$confirm({
        title: `催办提醒`,
        content: `您确认要催办本条数据吗?`,
        okText: '确认',
        okType: 'warrning',
        cancelText: '取消',
        onOk() {
          let params = {
            id: id,
          }
          _this.$http.post('/pipe-network/work_order_managements/urge', params).then(({ data }) => {
            _this.$message.success(`催办成功`)
          })
        },
        onCancel() {
          _this.$message.info('已取消催办')
        },
      })
    },
    deleteSelectRow() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      console.log(_this.selectedRows)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          _this.$http
            .delete(_this.deleteUrl, { data: _this.selectedRows })
            .then((res) => {
              if (res.code === 0) {
                _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
                _this.selectedRows = []
                _this.selectedRows.length = ''
                console.log(_this.selectedRows.length, 'llll')
                _this.queryList()
              }
            })
            .catch(() => {})
        },
        onCancel() {
          _this.selectedRows = []
          console.log(_this.selectedRows.length, 'lll')
          _this.$message.info('已取消删除')
        },
      })
    },
    // deleteSelectRow(id) {
    //   const _this = this
    //   this.$confirm({
    //     title: `删除提醒`,
    //     content: `您确认要删除本条数据吗?`,
    //     okText: '确认',
    //     okType: 'danger',
    //     cancelText: '取消',
    //     onOk() {
    //       _this.$http
    //         .delete(_this.deleteUrl, { data: [id] })
    //         .then((res) => {
    //           if (res.code === 0) {
    //             _this.$message.success(`删除成功`)
    //             _this.queryList()
    //           }
    //         })
    //         .catch(() => {})
    //     },
    //     onCancel() {
    //       _this.$message.info('已取消删除')
    //     },
    //   })
    // },
    resetList() {
      this.query = {
        pumpName: '',
        workName: '',
        workNo: '',
        workOrderType: undefined,
        deviceName: '',
        deviceNo: '',
        maintainPerson: '',
        status: this.statu,
        sysType: '二次供水',
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    callback(key) {
      this.statu = key
      console.log(key)
      if (key == '') {
        // this.query.status=''
      } else {
      }
      this.queryList()
    },
    getOrderTypeList() {
      const params = {
        dictCode: 'WORK_ORDER_TYPE',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        this.OrderTypeList = data
      })
    },
    PublishTask() {
      this.$refs.OrderModal.edit()
    },
    ReassignHandle(record) {
      this.$refs.OrderModal.ReassignHandle(record.id)
    },
    editHandle(record) {
      console.log(123)
      this.$refs.OrderModal.edit(record.id)
    },
    goDetails() {},
    selectChange(value) {
      this.addOrUpdateForm.accessorys = `${value}`
    },
    getTaskList() {
      const params = {
        dictCode: 'TASK_TYPE',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        
        this.TaskList = data
      })
    },
    EndOnChange(date, dateString) {
      this.query.endTime = dateString
    },
    StartOnChange(date, dateString) {
      this.query.startTime = dateString
    },

    detailInfo(record) {
      this.detailForm = { ...record }
    },
    showLineLayer(record) {
      this.geoJson = record.geoJson
      this.mapVisible = true
    },
    handleCancel() {},
    onOk(value) {},
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
